<template>
  <div>
    <div>{{ row.truck }}</div>
    <div v-if="row.stop">#{{ row.stop }}</div>
  </div>
</template>

<script>
export default {
  name: 'tdTruck',
  props: ['row']
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdTruck.vue